(function() {
  // Configuration - Edit these values
  const CONFIG = {
    currency: 'Rs.',
    steps: [
      { name: 'delivery', threshold: 6000, label: 'Free Delivery' },
      { name: 'sample', threshold: 7000, label: 'Freebie' },
      { name: 'gift', threshold: 12000, label: 'Free Gift' }
    ],
    // Set to true to hide a step
    hideSteps: {
      delivery: false,
      sample: true,
      gift: true
    }
  };

  function updateShippingProgress() {
    // Get cart total
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price / 100; // Convert cents to currency
        
        // Filter visible steps
        const visibleSteps = CONFIG.steps.filter(step => !CONFIG.hideSteps[step.name]);
        
        // Hide/show steps based on configuration
        CONFIG.steps.forEach(step => {
          const stepElement = document.querySelector(`[data-step="${step.name}"]`);
          if (stepElement) {
            if (CONFIG.hideSteps[step.name]) {
              stepElement.classList.add('hidden');
            } else {
              stepElement.classList.remove('hidden');
            }
          }
        });
        
        // Sort visible steps by threshold
        visibleSteps.sort((a, b) => a.threshold - b.threshold);
        
        // Update step states
        let activeStepIndex = -1;
        let nextMilestone = null;
        
        visibleSteps.forEach((step, index) => {
          const stepCircle = document.getElementById(`step${step.name.charAt(0).toUpperCase() + step.name.slice(1)}`);
          
          // FIXED: Only mark as completed if threshold is met, not just active
          if (cartTotal >= step.threshold) {
            stepCircle.classList.add('completed');
            stepCircle.classList.remove('active');
            activeStepIndex = index;
          } else {
            stepCircle.classList.remove('completed', 'active');
            // Mark as active only if it's the next milestone (not completed yet)
            if (nextMilestone === null) {
              nextMilestone = step;
              // Don't add active class - keep it inactive until threshold is reached
            }
          }
        });
        
        // Update progress fill
        const progressFill = document.getElementById('progressFill');
        let progressPercentage = 0;
        
        if (visibleSteps.length > 0) {
          if (activeStepIndex === visibleSteps.length - 1) {
            progressPercentage = 100;
          } else if (nextMilestone) {
            const prevThreshold = activeStepIndex >= 0 ? visibleSteps[activeStepIndex].threshold : 0;
            const nextThreshold = nextMilestone.threshold;
            const stepProgress = ((cartTotal - prevThreshold) / (nextThreshold - prevThreshold)) * 100;
            progressPercentage = ((activeStepIndex + 1) / visibleSteps.length + stepProgress / 100 / visibleSteps.length) * 100;
          }
        }
        
        progressFill.style.width = `${Math.min(progressPercentage, 100)}%`;
        
        // Update message
        const messageElement = document.getElementById('progressMessage');
        let message = '';
        
        if (cartTotal >= visibleSteps[visibleSteps.length - 1].threshold) {
          message = `🎉 Congratulations! You've unlocked all rewards!`;
        } else if (nextMilestone) {
          const amountNeeded = (nextMilestone.threshold - cartTotal).toFixed(0);
          message = `Shop for <span class="progress-amount">${CONFIG.currency}${amountNeeded}</span> more to get your <strong>${nextMilestone.label}</strong>!`;
        }
        
        messageElement.innerHTML = message;
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Initialize on page load
  updateShippingProgress();

  // FIXED: Listen for ALL cart-related events including quick add
  document.addEventListener('cart:updated', updateShippingProgress);
  document.addEventListener('cart:refresh', updateShippingProgress);
  document.addEventListener('cart:change', updateShippingProgress);
  
  // Listen for product added events (for quick add buttons)
  document.addEventListener('product:added', updateShippingProgress);
  document.addEventListener('product:add', updateShippingProgress);
  
  // Listen for AJAX cart events (common in Shopify themes)
  document.addEventListener('ajaxProduct:added', updateShippingProgress);
  document.addEventListener('ajaxCart:updated', updateShippingProgress);
  
  // Fallback: Listen for any cart drawer changes
  const observer = new MutationObserver(() => {
    if (document.querySelector('.cart-drawer') || document.querySelector('[data-cart-drawer]')) {
      updateShippingProgress();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // FIXED: More comprehensive click event listener for add to cart and quantity updates
  document.addEventListener('click', (e) => {
    // Quick add buttons
    if (e.target.closest('[data-quick-add]') || 
        e.target.closest('.quick-add') ||
        e.target.closest('[data-product-form]') ||
        e.target.closest('.product-form__submit') ||
        e.target.closest('[name="add"]') ||
        e.target.closest('[data-cart-update]') || 
        e.target.closest('.cart-item__quantity') ||
        e.target.closest('[name="updates[]"]')) {
      setTimeout(updateShippingProgress, 500);
    }
  });
  
  // FIXED: Listen for form submissions (catches all add to cart forms)
  document.addEventListener('submit', (e) => {
    if (e.target.matches('form[action*="/cart/add"]') || 
        e.target.matches('.product-form') ||
        e.target.matches('[data-product-form]')) {
      setTimeout(updateShippingProgress, 800);
    }
  });
  
  // FIXED: Intercept fetch requests to /cart/add.js (for AJAX add to cart)
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const promise = originalFetch.apply(this, args);
    
    // Check if this is a cart-related request
    if (args[0] && (
        args[0].includes('/cart/add') || 
        args[0].includes('/cart/change') || 
        args[0].includes('/cart/update'))) {
      promise.then(() => {
        setTimeout(updateShippingProgress, 300);
      });
    }
    
    return promise;
  };
})();